export enum Reward {
  None,
  Unknown,
  GreenPendant,
  StandardPendant,
  StandardCrystal,
  FairyCrystal
}
